import React from 'react';
import { validateSessionToken } from "account-portal-library/lib/helperFunctions";
import { getCallbacks } from 'account-portal-library/lib/emailSignIn.js';
import { getGotoUrlFromCookies } from '../../gotoUrl.js';
import TOVerifyCodeView from '../Views/TO/Code/VerifyCodeView';
import AppVars from '../../AppVars.js';
import axios from 'axios';
import navigateWithAnalytics from '../../analytics/navigateWithAnalytics.js';
import pushAnalytics from '../../analytics/pushAnalytics.js';

const appVars = AppVars.getInstance();

const ACCOUNT_LOCKED_URL = "/accountlocked";
const INVALID_CREDS_URL = "/invalidcreds";
const UNKNOWN_ERROR_URL = "/unknownerror";
const AUTHENTICATE_ENDPOINT = "/authenticate";

const COMPONENT_TREE = [{ component_name: 'VerifyAccount', component_version: '1.0.0' }];

class VerifyCode extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            OTPValue: "",
            isOTPValid: null,
            isCodeInvalid: false,
            isCodeExpired: false,
            isResponseValid: null,
            isCodeResent: null,
            displayUsername: sessionStorage.AP_SSID,
            onFocus: false,
            floatLabel: true,
            verificationType: this.props.signInType,
            userGuid: "",
            isLoginValid: null,
            isResendOtpDisabled: null,
        };
        this.submitOTP = this.submitOTP.bind(this);
        this.validateOTP = this.validateOTP.bind(this);
        this.handleOTPChange = this.handleOTPChange.bind(this);
        this.getNewOTP = this.getNewOTP.bind(this);
        this.handleSuccess = this.handleSuccess.bind(this);
        this.checkToken = this.checkToken.bind(this);
        this.handlePasswordLogin = this.handlePasswordLogin.bind(this);
        this.setFocus = this.setFocus.bind(this);
        this.removeFocus = this.removeFocus.bind(this);
        this.hideModal = this.hideModal.bind(this);
        this.onBlur = this.onBlur.bind(this);
        this.validateForm = this.validateForm.bind(this);
        this.sendJourneyPayload = this.sendJourneyPayload.bind(this);
        this.hideModalLocked = this.hideModalLocked.bind(this);
        this.hideModalInvalid = this.hideModalInvalid.bind(this);
        this.hideModalResend = this.hideModalResend.bind(this);
    }

    componentDidMount() {
        if (this.props.signInType === "PHONE" || this.props.signInType === "OTP") {
            const username = sessionStorage.AP_SSID;
            let displayPhone = "";
            try {
                displayPhone = "(" + username.substring(0, 3) + ") " + username.substring(3, 6) + "-" + username.substring(6, 10)
            } catch {
                displayPhone = username;
            }
            this.setState({ displayUsername: displayPhone })
        }
        else {
            this.setState({ displayUsername: this.props.username })
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.isCodeExpired !== this.state.isCodeExpired && this.state.isCodeExpired === true) {
            setTimeout(() => {
                window.location.href = "/";
            }, 5000);
        }
    }

    async sendJourneyPayload(journeyPayload, url, headers, params) {
        try {
            const resp = await axios({ method: 'post', url, headers, params, data: journeyPayload });
            return {
                response: resp.data,
                status: resp.status
            };
        } catch (error) {
            const status = error.response?.status;
            const data = error.response?.data;
            return {
                response: data,
                status: status,
                failureUrl: status === 401 ? data?.failureUrl || UNKNOWN_ERROR_URL : UNKNOWN_ERROR_URL
            };
        }
    };

    validateForm(status) {
        if (status > 299) {
            return false;
        }
        else {
            return true;
        }
    }

    async getNewOTP() {
        try {
            pushAnalytics('aa-action', { button_action: 'resendOTP', ctaText: 'Request New Code', link_text: 'Request New Code', link_trigger: 'aa-link', content_section: `Sign in Verify by ${(this.props.signInType === "PHONE" || this.props.signInType === "OTP") ? "Text" : "Email"}`, initiator: 'user' }, COMPONENT_TREE);
            this.setState({ isCodeInvalid: false });
            let resendPayload = this.props.payload;
            if (this.state.payload) {
                resendPayload = { ...this.state.payload };
            }
            resendPayload.callbacks[1].input[0].value = "";
            resendPayload.callbacks[2].input[0].value = 1;
            const url = appVars.getBaseUrl() + "/" + appVars.getName() + '/json' + appVars.getRealm() + AUTHENTICATE_ENDPOINT;
            const params = {
                'authIndexType': 'service',
                'authIndexValue': this.props.acr_values === "MFA" ? appVars.getMFATree() : this.props.showForm === "RESET" ? appVars.getMFATree() : appVars.getSignInTree()
            };
            const headers = {
                'Accept-API-Version': 'resource=1.1',
                'Content-Type': 'application/json',
                ...(this.props.uid ? { 'x-username': this.props.uid } : {}),
            };
            const journeyResponse = await this.sendJourneyPayload(resendPayload, url, headers, params);
            // console.log("Journey Response(OTP Resend) -> ", journeyResponse)
            if (journeyResponse.status !== 200) {
                this.setState({ isResponseValid: false });
                throw journeyResponse.response;
            }
            this.setState({ payload: journeyResponse.response, isCodeResent: true });
        } catch (errorResponse) {
            // console.log("Error -> ", errorResponse);
            this.handleFailure(errorResponse);
        }
    }

    async submitOTP(event) {
        event.preventDefault();
        try {
            if (this.state.isOTPValid) {
                this.setState({ loading: true, isLoginValid: null, isCodeInvalid: false, isResponseValid: null })
                let submitPayload = this.props.payload;
                if (this.state.payload) {
                    submitPayload = { ...this.state.payload };
                }
                submitPayload.callbacks[1].input[0].value = this.state.OTPValue;
                submitPayload.callbacks[2].input[0].value = 0;
                const url = appVars.getBaseUrl() + "/" + appVars.getName() + '/json' + appVars.getRealm() + AUTHENTICATE_ENDPOINT;
                const params = {
                    'authIndexType': 'service',
                    'authIndexValue': this.props.acr_values === "MFA" ? appVars.getMFATree() : this.props.showForm === "RESET" ? appVars.getMFATree() : appVars.getSignInTree()
                };
                const headers = {
                    'Accept-API-Version': 'resource=2.1',
                    'Content-Type': 'application/json',
                    ...(this.props.uid ? { 'x-username': this.props.uid } : {}),
                };
                const journeyResponse = await this.sendJourneyPayload(submitPayload, url, headers, params);
                // console.log("Journey Response(OTP Submit) -> ", journeyResponse)
                if (journeyResponse.status !== 200) {
                    this.setState({ isResponseValid: false });
                    throw journeyResponse.response;
                }
                else if (journeyResponse.response?.callbacks?.length === 3 || journeyResponse.response?.callbacks?.[0]?.output?.[0]?.value === "Invalid OTP") {
                    this.setState({ payload: journeyResponse.response, isCodeInvalid: true, isLoginValid: false, loading: false })
                    pushAnalytics("sys-action", {
                        displayed_error_message: 'Invalid OTP. An excessive number of failed attempts will temporarily lock your account.',
                        form_name: "submitOTPLogin",
                        field_name: 'otp',
                        error_type: 'validation',
                        content_section: `Sign in Verify by ${(this.props.signInType === "PHONE" || this.props.signInType === "OTP") ? "Text" : "Email"}`,
                        metrics: 'km-form_field_submit-error',
                        user_login_source: 'Email',
                    }, COMPONENT_TREE);
                }
                else {
                    this.setState({ payload: journeyResponse.response });
                    if (journeyResponse.response?.callbacks) {
                        this.handleContinue(journeyResponse.response);
                    } else {
                        this.handleSuccess(journeyResponse.response);
                    }
                }
            }
        } catch (errorResponse) {
            // console.log("Error -> ", errorResponse);
            this.handleFailure(errorResponse);
        }
    }

    async handleContinue(journeyResponse) {
        this.props.savePayload(journeyResponse);
        if (journeyResponse.callbacks[0].type === "TextOutputCallback") {
            if (journeyResponse?.callbacks?.[1]?.type === "TextOutputCallback") {
                pushAnalytics("sys-action", {
                    displayed_error_message: 'This account is locked for 15 minutes due to multiple failed attempts. Please try again later or contact us for help unlocking your account.',
                    form_name: "submitOTPLogin",
                    field_name: 'otp',
                    error_type: 'validation',
                    content_section: `Sign in Verify by ${(this.props.signInType === "PHONE" || this.props.signInType === "OTP") ? "Text" : "Email"}`,
                    metrics: 'km-form_field_submit-error',
                    user_login_source: 'Email',
                }, COMPONENT_TREE);
                this.handleAccountLockout(journeyResponse);
            } else if (journeyResponse?.callbacks?.[1]?.type === "HiddenValueCallback") {
                this.addFingerPrint(journeyResponse);
            }
        } else {
            this.props.displayForm("PASSWORD");
        }
    }

    async handleAccountLockout(journeyPayload) {
        try {
            const url = appVars.getBaseUrl() + "/" + appVars.getName() + '/json' + appVars.getRealm() + AUTHENTICATE_ENDPOINT;
            const params = {
                'authIndexType': 'service',
                'authIndexValue': this.props.acr_values === "MFA" ? appVars.getMFATree() : this.props.showForm === "RESET" ? appVars.getMFATree() : appVars.getSignInTree()
            };
            const headers = {
                'Accept-API-Version': 'resource=2.1',
                'Content-Type': 'application/json',
                'x-username': this.props.uid || sessionStorage.AP_SSID
            };
            const journeyResponse = await this.sendJourneyPayload(journeyPayload, url, headers, params);
            if (journeyResponse.status !== 200) {
                this.setState({ isResponseValid: false });
                throw journeyResponse.response;
            } else if (journeyResponse.response.callbacks[0].type == 'RedirectCallback') {
                const redirectValue = journeyResponse.response.callbacks[0].output[0].value;
                navigateWithAnalytics(redirectValue, "callback-redirect", "auto");
            } else {
                navigateWithAnalytics(UNKNOWN_ERROR_URL, "error-redirect", "auto");
            }
        } catch (errorResponse) {
            // console.log("Error -> ", errorResponse);
            this.handleFailure(errorResponse);
        }
    }

    async addFingerPrint(payload) {
        try {
            const url = appVars.getBaseUrl() + '/' + appVars.getName() + '/json' + appVars.getRealm() + AUTHENTICATE_ENDPOINT;
            const headers = {
                'Accept-API-Version': 'resource=2.1',
                'Content-Type': 'application/json'
            }
            const params = {
                'authIndexType': 'service',
                'authIndexValue': appVars.getMFATree()
            }

            if (payload.callbacks[1] != null) {
                // set fingerprint value
                payload.callbacks[1].input[0].value = `{"screen":{"screenWidth":${window.screen.width},"screenHeight":${window.screen.height},"screenColourDepth":${window.screen.colorDepth}},"timezone":{"timezone":"${new Date().getTimezoneOffset()}"},"plugins":{"installedPlugins":"internal-pdf-viewer;internal-pdf-viewer;internal-pdf-viewer;internal-pdf-viewer;internal-pdf-viewer;"},"fonts":{"installedFonts":"cursive;monospace;serif;sans-serif;fantasy;default;Arial;Arial Black;Arial Narrow;Bookman Old Style;Bradley Hand ITC;Century;Century Gothic;Comic Sans MS;Courier;Courier New;Georgia;Impact;Lucida Console;Monotype Corsiva;Papyrus;Tahoma;Times;Times New Roman;Trebuchet MS;Verdana;"},"userAgent":"${navigator.userAgent}","language":"${navigator.language}"}`;
                /* eslint-enable max-len */
            }
            const fingerPrintResponse = await this.sendJourneyPayload(payload, url, headers, params);
            if (fingerPrintResponse.status !== 200) {
                throw fingerPrintResponse.response;
            }
            this.setState({ loading: false })
            this.props.savePayload(fingerPrintResponse.response);
            if (fingerPrintResponse.response.callbacks[0].type === 'PasswordCallback') {
                this.props.saveStep("PASSWORD");
            } else {
                this.setState({ loading: true });
                const tokenValid = await this.checkToken(fingerPrintResponse.response);
                this.setState({ loading: false })
                if (tokenValid) {
                    const gotoUrl = getGotoUrlFromCookies(['T']);
                    navigateWithAnalytics(gotoUrl, "cookie-redirect", "auto");
                } else {
                    navigateWithAnalytics(UNKNOWN_ERROR_URL, "error-redirect", "auto");
                }
            }
        } catch (errorResponse) {
            // console.log("Error -> ", errorResponse);
            this.handleFailure(errorResponse);
        }
    }

    async handlePasswordLogin() {
        try {
            pushAnalytics('aa-link', {
                ctaText: 'Sign in with Password',
                link_text: 'Sign in with Password',
                link_type: 'link',
                link_trigger: 'aa-link',
                content_section: 'Sign in Verify by Password',
            }, COMPONENT_TREE);
            const url = appVars.getBaseUrl() + "/" + appVars.getName() + '/json' + appVars.getRealm() + AUTHENTICATE_ENDPOINT;
            // const url = appVars.getAMBaseURL() + '/json' + appVars.getRealm() + '/authenticate';
            const params = {
                'authIndexType': 'service',
                'authIndexValue': appVars.getSignInTree()
            };
            const headers = {
                'Accept-API-Version': 'resource=2.0',
                'Content-Type': 'application/json',
            };
            const startJourney = await getCallbacks(url, headers, params);
            const initialResponse = startJourney.response;

            const username = sessionStorage.AP_SSID;
            const otpUsername = this.props.signInType === "OTP" ? ("noverify-" + username) : username;

            if (startJourney.status < 299) {
                initialResponse.callbacks[0].input[0].value = otpUsername;
                initialResponse.callbacks[1].input[0].value = "TO";
            }

            const journeyResponse = await this.sendJourneyPayload(initialResponse, url, headers, params);
            // console.log("CheckUsername JourneyResponse -> ", journeyResponse)

            if (journeyResponse.status !== 200) {
                this.setState({ isResponseValid: false });
                throw journeyResponse.response;
            }
            this.props.savePayload(journeyResponse.response);
            this.props.displayForm("PASSWORD");
        } catch (errorResponse) {
            // console.log("Error -> ", errorResponse);
            this.handleFailure(errorResponse);
        }
    }

    validateOTP(code) {
        if (code == null || code.trim().length !== 6) {
            return false;
        } else {
            return !isNaN(code);
        }
    }

    handleOTPChange(value) {
        this.setState({ OTPValue: value }, () => {
            // Wipe the invalid verification after typing
            if (this.state.isCodeInvalid) {
                this.setState({ isCodeInvalid: false })
            }
            // Wipe the resent notification after typing
            if (this.state.isCodeResent) {
                this.setState({ isCodeResent: false })
            }
            // Error message was previously showing but now the code is a valid OTP so remove it
            if (this.state.isOTPValid !== true && this.validateOTP(value)) {
                this.setState({ isOTPValid: true })
            } // If the otp valid state was valid but is no longer valid update the error message
            else if (this.state.isOTPValid === true && !this.validateOTP(value)) {
                this.setState({ isOTPValid: false })
            }
        });
    }

    //Checks that there is a session cookie on the browser
    async checkToken(journeyResponse) {
        try {
            const tokenId = journeyResponse.tokenId;
            if (tokenId != null) {
                // console.log("Token ID -> ", tokenId)
                const validateResponse = await validateSessionToken(tokenId, appVars.getBaseUrl(), appVars.getName(), appVars.getRealm());
                // console.log("validateResponse -> ", validateResponse);
                return validateResponse.response.valid;
            } else {
                return false;
            }
        }
        catch {
            return false;
        }

    }

    handleFailure(journeyResponse) {
        const failureUrl = journeyResponse?.detail?.failureUrl || journeyResponse?.failureUrl;
        const errorMessage = journeyResponse?.detail?.errorMessage || journeyResponse?.message;
        debugger;
        // Multiple OTP resends
        if (errorMessage === "Login failure") {
            this.setState({ loading: false, isResendOtpDisabled: true });
        }
        // Invalid credentials - after 5 unsuccessful OTP attempts
        else if (failureUrl === ACCOUNT_LOCKED_URL || errorMessage === "User Locked Out.") {
            this.setState({ loading: false, isAccountLocked: true });
        }
        // OTP expired after 5 minutes
        else if (errorMessage === 'Session has timed out') {
            this.setState({ loading: false, isCodeExpired: true });
        }
        // If invalid credentials
        else if (failureUrl === INVALID_CREDS_URL) {
            this.setState({ isLoginValid: false, loading: false });
        }
        // If invalid credentials
        else if (failureUrl != null) {
            navigateWithAnalytics(failureUrl, "error-redirect", "auto");
        }
        else {
            //this.setState({loading: false})
            navigateWithAnalytics(UNKNOWN_ERROR_URL, "error-redirect", "auto");
        }
    }

    async handleSuccess(journeyResponse) {
        const tokenValid = await this.checkToken(journeyResponse);
        // console.log("Token Valid -> ", tokenValid);

        if (tokenValid) {
            pushAnalytics('aa-link', { button_action: 'submitOTP', link_text: 'sign in', link_trigger: 'aa-link', user_login_source: 'Email', ctaText: 'SUBMIT', content_section: `Sign in Verify by ${(this.props.signInType === "PHONE" || this.props.signInType === "OTP") ? "Text" : "Email"}`, initiator: 'user' }, COMPONENT_TREE, "Logged In");
            const gotoUrl = getGotoUrlFromCookies(['T', 'S']);
            navigateWithAnalytics(gotoUrl, "cookie-redirect", "auto");
        } else {
            // Token was invalid for a successful response
            navigateWithAnalytics(UNKNOWN_ERROR_URL, "error-redirect", "auto");
        }
    }

    setFocus(event) {
        this.setState({ onFocus: true })
        this.setState({ floatLabel: false })
    }

    removeFocus() {
        this.setState({ onFocus: false })
    }

    onBlur() {
        if (this.state.OTPValue === "" || this.state.OTPValue === null) {
            this.setState({ floatLabel: true })
        } else {
            this.setState({ floatLabel: false })
        }
        this.removeFocus()
        this.setState({ isOTPValid: this.validateOTP(this.state.OTPValue) })
    }

    hideModalLocked() {
        this.setState({ isAccountLocked: null });
    }

    hideModalInvalid() {
        this.setState({ isLoginValid: null });
    }

    hideModalResend() {
        this.setState({ isResendOtpDisabled: null });
    }

    hideModal() {
        this.setState({ isResponseValid: null })
    }

    render() {
        return (
            <TOVerifyCodeView
                showForm={this.props.showForm}
                loading={this.state.loading}
                displayUsername={this.state.displayUsername}
                signInType={this.props.signInType}
                OTPValue={this.state.OTPValue}
                isCodeInvalid={this.state.isCodeInvalid}
                isCodeExpired={this.state.isCodeExpired}
                isOTPValid={this.state.isOTPValid}
                isCodeResent={this.state.isCodeResent}
                isResponseValid={this.state.isResponseValid}
                handleOTPChange={this.handleOTPChange}
                submitOTP={this.submitOTP}
                getNewOTP={this.getNewOTP}
                handlePasswordLogin={this.handlePasswordLogin}
                onFocus={this.state.onFocus}
                setFocus={this.setFocus}
                removeFocus={this.removeFocus}
                hideModalLocked={this.hideModalLocked}
                isAccountLocked={this.state.isAccountLocked}
                hideModalInvalid={this.hideModalInvalid}
                isLoginValid={this.state.isLoginValid}
                hideModalResend={this.hideModalResend}
                isResendOtpDisabled={this.state.isResendOtpDisabled}
                hideModal={this.hideModal}
                style={this.props.style}
                onBlur={this.onBlur}
                floatLabel={this.state.floatLabel}
            />
        );
    }
}

export default VerifyCode;